import React from 'react';
import { compactProjectMetric, getProjectHeatTier } from '../../utils/projectOperationsSummary';

const METRICS = [
  { key: 'heat', label: '热度', fullLabel: '热度' },
  { key: 'favorites', label: '收藏', fullLabel: '收藏数' },
  { key: 'episodeOneLikes', label: '首集赞', fullLabel: '第一集点赞数' },
  { key: 'episodeOneComments', label: '首集评', fullLabel: '第一集评论数' },
];

export default function ProjectOperationsSummary({ summary, compact = false }) {
  const record = summary?.latestMetric;
  if (!record) return null;
  const metrics = METRICS.map(item => ({ ...item, formatted: compactProjectMetric(record[item.key]) })).filter(item => item.formatted);
  if (!metrics.length) return null;
  return <div className={`studio-project-operations-summary${compact ? ' studio-project-operations-summary--inline' : ''}${metrics.length === 4 ? ' studio-project-operations-summary--four-metrics' : ''}`} style={{ '--project-metric-count': metrics.length }} aria-label={`最新运营数据${record.date ? `，${record.date}` : ''}`}>
    <p className="studio-project-operations-summary__date"><span>最新记录</span>{record.date ? <time dateTime={record.date}>{record.date}</time> : <span>日期未提供</span>}</p>
    <dl>{metrics.map(item => (
      <div className="studio-project-operations-summary__metric" data-metric={item.key} data-heat-tier={item.key === 'heat' ? getProjectHeatTier(record.heat) : undefined} key={item.key} title={`${item.fullLabel}：${item.formatted.original}（原始数值）`}>
        <dt>
          {item.key === 'heat' ? (
            <svg className="studio-project-operations-summary__flame" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
              <path d="M12 2c0 6-7 7-7 13a7 7 0 0 0 14 0c0-3-2-5-4-7 0 3-1 4-3 5 1-4 0-7 0-11Z" />
            </svg>
          ) : null}
          {item.label}
        </dt>
        <dd aria-label={`${item.fullLabel} ${item.formatted.original}`}>{item.formatted.text}</dd>
      </div>
    ))}</dl>
  </div>;
}
